export default "__VITE_ASSET__BEGjh8VW__"